<template>
	
	<div>
		
		<layout>

			<template v-slot:title> 
				EDITAR POST
			</template>

			<template v-slot:subtitle> 
				EDITAR POST
			</template>

			<template v-slot:content>

				<v-container>


					<v-row class="mt-4 mb-4">
						<v-col offset-lg="2" lg="8">

							<form @submit.prevent="update()">
								
								<v-card light class="pa-5" elevation="5">

									<v-text-field
							      label="Titulo"
							      filled
							      required
							      v-model="post.title"
							    ></v-text-field> 


							    <v-file-input 
				          	label="Actualizar imagen de portada"
				          	filled
				          	v-model="post.img"
				          ></v-file-input>

				          <img :src="backend+'../storage/app/'+post.imgPreview" width="100" />


				          <v-textarea
					          label="Texto introductorio"
					          filled
					          required
					          v-model="post.introduction"
					        ></v-textarea>


									<div>
										<h4>Contenido</h4>
										<div id="content_edit" style="min-height: 400px;"></div>
									</div>
							    

		      	      <v-btn dark large block class="mt-5" type="submit">
		      		      Actualizar
		      		    </v-btn>

								</v-card>

							</form>

						</v-col>
					</v-row>
				</v-container>

			</template>

		</layout>
		

	</div>

</template>


<style src="./quill.snow.css"></style>


<script>
	
	import Layout from './../../../layout/Layout'
	import BlogService from '@/shared/services/BlogService'

	import { loadScript } from "vue-plugin-load-script"


	export default 
	{
		
		data() {
			return {
				post: {
					id: this.$route.params.id,
					title: null,
					content: null,
					introduction: null,
					imgPreview: null,
					img: null
				}
			}
		},

		components: {
			Layout
		},

		mounted() {
			this.getData()
		},

		methods: {

			async getData()
			{
				const resp = await BlogService.getOne(this.post.id)
				this.post.title = resp.data.title;
				this.post.content = resp.data.content;
				this.post.introduction = resp.data.introduction;
				this.post.imgPreview = resp.data.img;

				// init editor
				let url = 'https://cdn.quilljs.com/1.3.6/quill.js'
				await loadScript(url)


				let options = {

				  modules: {
				    toolbar: [
				    	[{ 'header': [1, 2, 3, 4, 5, 6, false] }],

				    	['bold', 'italic', 'underline', 'strike'],  

				    	[{ 'align': [] }],

				    	[{ 'indent': '-1'}, { 'indent': '+1' }],

				    	[{ 'color': [] }, { 'background': [] }],

				    	['link'],
						                     
						  ['clean'] 
				    ]
				  },

				  theme: 'snow'
				};

				let editor = new Quill('#content_edit', options);


				setTimeout(()=> 
				{
					if(this.post.content != "undefined")
						$('#content_edit .ql-editor').html(this.post.content)
				}, 500)
			},

			async update()
			{
				const form = new FormData();
				form.append('id', this.post.id)
				form.append('title', this.post.title)
				form.append('img', this.post.img)
				form.append('introduction', this.post.introduction)
				form.append('content', $('#content_edit .ql-editor').html())

    		const resp = await BlogService.update(form)

    		console.log(resp.data)

    		if(resp.data == 'OK')
    		{
    			this.$router.push('/cms/blog/')
    			SwalMixin('Post editado', 'success')
    		}
    		else
    			SwalAlert('', 'Ha ocurrido un error, por favor intenta de nuevo')
			}

		}

	}

</script>